import React from "react";
import "../styles/Hero.css";

/**
 * Hero Section Component
 * Clean, professional landing section with clear value proposition and CTAs
 */
function Hero() {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-inner">
        {/* Headline */}
        <div className="hero-content">
          <h1 className="hero-title">
            Expert Software Development, Cybersecurity & Technical Support
          </h1>

          <p className="hero-subtitle">
            Building secure, scalable digital solutions for modern businesses.
          </p>

          {/* CTAs */}
          <div className="hero-actions">
            <a
              href="#contact"
              className="btn-primary"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("contact");
              }}
            >
              Get Started
            </a>

            <button
              className="btn-secondary"
              onClick={() => scrollToSection("services")}
            >
              Explore Services
            </button>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="hero-trust">
          <div className="trust-item">
            <span className="trust-number">50+</span>
            <span className="trust-label">Projects Delivered</span>
          </div>

          <div className="trust-item">
            <span className="trust-number">30+</span>
            <span className="trust-label">Clients Served</span>
          </div>

          <div className="trust-item">
            <span className="trust-number">4+</span>
            <span className="trust-label">Years Experience</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
